module.exports = __webpack_public_path__ + "img/book-module-character-info.81c8bf37.png";